exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2VsrbZabdkIYWBZ-jkF1xP {\n  background: transparent;\n}\n._2VsrbZabdkIYWBZ-jkF1xP:hover {\n  background: transparent;\n}\n._2VsrbZabdkIYWBZ-jkF1xP ._32dzSdyIiEnjgZHurvUt4U {\n  padding: 2px;\n}\n", ""]);

// Exports
exports.locals = {
	"ProjectIndicator": "_2VsrbZabdkIYWBZ-jkF1xP",
	"ProjectIndicatorAvatar": "_32dzSdyIiEnjgZHurvUt4U"
};